import React from 'react'
import axios from 'axios';

export const getalluser = async (data) => {
    try {
        return await axios.get(`${process.env.REACT_APP_MYAPI_URL}/getallusers`);
    } catch (error) {
        console.log('Error while calling addUser API', error);
    }
};

//role
export const addrole = async (data) => {
    try {
        return await axios.post(`${process.env.REACT_APP_MYAPI_URL}/addrole`, data);
    } catch (error) {
        console.log('while CapType api fetching Error ', error);
        return error.response;
    }
};

export const getroles = async () => {
    try {
        return await axios.get(`${process.env.REACT_APP_MYAPI_URL}/getroles`);
    } catch (error) {
        console.log('Error while calling get CapType API ', error);
        return { data: null, error: error.response };
    }
};

export const deleteuser = async (id) => {
    try {
        return await axios.delete(`${process.env.REACT_APP_MYAPI_URL}/deleteuser/${id}`)
    } catch (error) {
        console.log('Error while calling api', error);
    }
}

export const getroledata = async (type) => {
    try {
        return await axios.get(`${process.env.REACT_APP_MYAPI_URL}/rolegetbyname/${type}`);
    } catch (error) {
        console.log('Error while calling get CapType API ', error);
        return { data: null, error: error.response };
    }
};


export const savePType = async (data) => {
    try {
        return await axios.post(`${process.env.REACT_APP_MYAPI_URL}/PType`, data);
    } catch (error) {
        console.log(`Error while calling savePType Api`, error);
    }
};


export const getptype = async () => {
    try {
        return await axios.get(`${process.env.REACT_APP_MYAPI_URL}/PTypeList`);
    } catch (error) {
        console.log('Error while calling get savePType API ', error);
    }
}

// api to get getPREDRFbyid
export const getptypeById = async (id) => {
    try {
        return await axios.get(`${process.env.REACT_APP_MYAPI_URL}/getptypeById/${id}`);
    } catch (error) {
        console.log('Error while calling get getpredrfid API ', error);
    }
}

//update mfrsites
export const updategetptype = async (id, data) => {
    try {
        const response = await axios.put(`${process.env.REACT_APP_MYAPI_URL}/Editptype/${id}`, data);
        return response.data;
    } catch (error) {
        // Handle error
        console.error('Error updating PREDRF:', error);
        throw error;
    }
};

//delete predrf

export const deletegetptype = async (id) => {
    try {
        return await axios.delete(`${process.env.REACT_APP_MYAPI_URL}/PTypeList/${id}`)
    } catch (error) {
        console.log('Error while calling deletePredrf api', error);
    }
}

export const savepStyle = async (data) => {
    try {
        return await axios.post(`${process.env.REACT_APP_MYAPI_URL}/pStyle`, data);
    } catch (error) {
        console.log(`Error while calling savePType Api`, error);
    }
};


export const getpStyle = async () => {
    try {
        return await axios.get(`${process.env.REACT_APP_MYAPI_URL}/PStyleList`);
    } catch (error) {
        console.log('Error while calling get savePType API ', error);
    }
}

// api to get getPREDRFbyid
export const getpstyleById = async (id) => {
    try {
        return await axios.get(`${process.env.REACT_APP_MYAPI_URL}/getpstyleById/${id}`);
    } catch (error) {
        console.log('Error while calling get getpredrfid API ', error);
    }
}


//update mfrsites
export const updategetpstyle = async (id, data) => {
    try {
        const response = await axios.put(`${process.env.REACT_APP_MYAPI_URL}/Editpstyle/${id}`, data); // Assuming your backend endpoint is '/api/mfrsites/:id'
        return response.data;
    } catch (error) {
        // Handle error
        console.error('Error updating PREDRF:', error);
        throw error;
    }
};

//delete predrf

export const deletegetpstyle = async (id) => {
    try {
        return await axios.delete(`${process.env.REACT_APP_MYAPI_URL}/PStyleList/${id}`)
    } catch (error) {
        console.log('Error while calling deletePredrf api', error);
    }
}